import React, { createContext, useContext, useEffect, useState } from "react";

const ShopContext = createContext();

export const ShopProvider = ({ children }) => {
  const [shopId, setShopId] = useState(() => {
    return sessionStorage.getItem("shop_id") || "16";
  });

  useEffect(() => {
    if (shopId) {
      sessionStorage.setItem("shop_id", shopId);
    } else {
      sessionStorage.removeItem("shop_id");
    }
  }, [shopId]);

  const clearShop = () => {
    setShopId("");
    sessionStorage.removeItem("shop_id");
  };

  return (
    <ShopContext.Provider value={{ shopId, setShopId, clearShop }}>
      {children}
    </ShopContext.Provider>
  );
};

export const useShop = () => useContext(ShopContext);